module.exports = __webpack_public_path__ + "img/tango_single.48f5a1f1.png";